import BannerDocs from "./Banner";

export default BannerDocs;
